(ns teamoesterreich.admin-mode.event-alarm.detail.alarm-event-selector
  (:require [clojure.string]
            [goog.string.format]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [goog.json :as json]
            [clojure.string :as str]
            [teamoesterreich.admin-mode.ui-helper.are-you-sure-modal :as ays-modal]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.log :as log]

            [teamoesterreich.view-state :as store]
            [teamoesterreich.admin-mode.data.eventAlarm :as d-eventAlarm]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.event :as d-events]



            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.done :refer [done]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            ))

(defn get-event-options []

  (let [!event-list-state (r/cursor store/app-state [:event :event-list-state])
        !loaded? (r/cursor !event-list-state [:loaded])
        !data (r/cursor !event-list-state [:data])]
    (when (not @!loaded?)
      (d-events/get-event-list-elements
        (fn [data]
          (swap! !event-list-state assoc
                 :data data
                 :loaded true))
        ))
    (into {} (mapv (fn [[k e]]
                     [k (str (:crowdtaskerEvent-name e) (when (:crowdtaskerEvent-timeFrom e) (str " - " (h/date-time-ger-fromT (:crowdtaskerEvent-timeFrom e)))))])
                   (filter (fn [[k e]]
                             (and
                               true
                               (not= (:crowdtaskerEvent-status e) "finished")

                               )) @!data)))
    ))


(defn select-event-popup [!open on-ok-fn & [on-cancel-fn]]
  (let [!new-event (r/atom nil)]
    (fn [!open on-ok-fn & [on-cancel-fn]]
      [mui/modal
       {
        :aria-labelledby  "simple-modal-title"
        :aria-describedby "simple-modal-description"
        :style            {:display        "flex"
                           :marginRight    "auto"
                           :marginLeft     "auto"
                           :alignItems     "center"
                           :justifyContent "center"}
        :open             (or @!open false)

        }
       [:div
        {
         :class "modal"
         :style {:width 600}}
        [:h4 "Einsatz wählen"]

        ;[:pre (pr-str (get-event-options))]
        [mui/form-control
         {
          :fullWidth true
          }
         [mui/select
          {:multiple false
           :value    (or @!new-event "")
           :onChange (fn [v]
                       (println @!new-event "->" (h/event-value v))
                       (reset! !new-event (h/event-value v)))
           }
          (doall (for [[k v] (get-event-options)]
                   ^{:key (str "event-option-" k)}
                   [mui/menu-item {:value k}
                    [mui/list-item-text v]
                    ]))
          ]]

        [:br]
        [:br]
        [mui/button
         {:color     "primary"
          :variant   "contained"
          :startIcon (r/as-element [keyboard-arrow-left])
          :style     {:marginRight 50}
          :onClick   (fn []
                       (if on-cancel-fn
                         (on-cancel-fn)
                         (reset! !open false)))
          }
         "Abbrechen"]
        [mui/button
         {:style     {:float "right"}
          :variant   "contained"
          :startIcon (r/as-element [done])
          :onClick   (fn []
                       (on-ok-fn @!new-event)
                       (reset! !open false))
          }
         "Ok"]]
       ]
      )))

(defn get-it [!actual-alarm !event-detail-loaded? disabled]
  (let [!st (r/atom {:select-popup false :show-delete-modal nil})
        !select-popup (r/cursor !st [:select-popup])
        !show-delete-modal (r/cursor !st [:show-delete-modal])]
    (fn []
      [mui/card
       [mui/card-content {:style {:textAlign "left"}}
        [select-event-popup !select-popup
         (fn [event-uuid]
           (println "add " event-uuid)
           (d-eventAlarm/>alarm-add-event (:eventAlarm-uuid @!actual-alarm) event-uuid
                                          (fn [data]
                                            (reset! !actual-alarm data))))]

        [ays-modal/are-you-sure-modal !show-delete-modal "Willst du wirklich diesen Einssatz entfernen?" "Entfernen"
         (fn [uuid] (d-eventAlarm/>alarm-remove-event (:eventAlarm-uuid @!actual-alarm) uuid
                                                      (fn [data]
                                                        (reset! !actual-alarm data))))]
        [mui/button {
                     :variant   "contained"
                     :startIcon (r/as-element [edit])
                     :onClick   #(reset! !select-popup true)
                     } "Einsatz hinzufügen" @!select-popup]

        [mui/table
         [mui/table-head
          [mui/table-row
           [mui/table-cell "#"]
           [mui/table-cell "Einssatzname"]
           [mui/table-cell "Status"]
           [mui/table-cell "Verb/Dst"]
           [mui/table-cell "Zusage bis"]
           [mui/table-cell "Start"]
           [mui/table-cell "Ende"]
           ]]

         [mui/table-body
          (for [entry (:eventAlarm-events @!actual-alarm)]
            ^{:key (str "event-" (:crowdtaskerEvent-uuid entry))}
            [mui/table-row
             [mui/table-cell [mui/icon-button {:label   "löschen"
                                               :onClick #(reset! !show-delete-modal (:crowdtaskerEvent-uuid entry))
                                               } [delete-forever {:fontSize "small"}]]]
             [mui/table-cell (:crowdtaskerEvent-name entry)]
             [mui/table-cell {:style {:background-color (if (not= (:crowdtaskerEvent-status entry) "collecting") "red" "white")}} (case (:crowdtaskerEvent-status entry)
                                                                                                                                    "created" "Erstellen"
                                                                                                                                    "waitAccept" "Wartet auf Freigabe"
                                                                                                                                    "collecting" "Sammelt Rückmeldungen"
                                                                                                                                    "running" "Einsatz läuft"
                                                                                                                                    (:crowdtaskerEvent-status entry)
                                                                                                                                    )]
             [mui/table-cell (:crowdtaskerEvent-orgId entry)]
             ;
             [mui/table-cell (if (:crowdtaskerEvent-acceptableUntil entry) (h/date-time-ger-fromT (:crowdtaskerEvent-acceptableUntil entry)) "-")]
             [mui/table-cell (if (:crowdtaskerEvent-timeFrom entry) (h/date-time-ger-fromT (:crowdtaskerEvent-timeFrom entry)) "-")]
             [mui/table-cell (if (:crowdtaskerEvent-timeTo entry) (h/date-time-ger-fromT (:crowdtaskerEvent-timeTo entry)) "-")]
             ])
          ]
         ]
        ]]

      )))














